import axios from "axios";

export default function api() {

    const baseURL = process.env.REACT_APP_API_URL;

    return axios.create({
        baseURL: baseURL,
        headers: {
            // Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQURNSU4iLCJzdWIiOiJBZG1pbiIsImlhdCI6MTcwNTE1MTc0MiwiZXhwIjo1MzA1MTUxNzQyfQ.2s9AofKi5zA3cLTF1tiB1-mAXO7iVDPguQbA6bfjESM`
            Authorization: `Bearer eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiQURNSU4iLCJzdWIiOiJBZG1pbiIsImlhdCI6MTcwNTE1MTc0MiwiZXhwIjo1MzA1MTUxNzQyfQ._VsXBnnd0qdTS5v_fUcVPwdnv_moiirzGl7oBwu2usc`
        }
    });
}
